module.exports = __webpack_public_path__ + "img/device-MT5.e28c6228.png";